import React, { useEffect, useState } from "react";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CSmartTable,
  CSpinner,
  CPopover,
  CButton,
} from "@coreui/react-pro";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const NotificationLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${BASE_URL}/api/apn/logs`);
        if (!res.ok) throw new Error("Failed to fetch logs.");
        const { data } = await res.json();

        const parsedLogs = data.map((log) => ({
          ...log,
          Users: JSON.parse(log.Users),
        }));

        setLogs(parsedLogs);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load logs.");
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, []);

  const columns = [
    { key: "index", label: "Index", _style: { width: "5%" } },
    { key: "Title", label: "Title", _style: { width: "25%" } },
    { key: "Message", label: "Message", _style: { width: "25%" } },
    { key: "Users", label: "Users", _style: { width: "35%" } },
    { key: "CreatedAt", label: "Date", _style: { width: "10%" } },
  ];

  const scopedColumns = {
    index: (item, index) => {
      return <td>{index + 1}</td>;
    },
    Users: (item) => {
      const visibleEmails = item.Users.slice(0, 2)
        .map((u) => u.email)
        .join(", ");
      const remainingUsers = item.Users.slice(2);
      const remainingEmails = remainingUsers.map((u) => u.email).join(", ");

      return (
        <td>
          {visibleEmails}
          {remainingUsers.length > 0 && (
            <>
              ,{" "}
              <CPopover
                content={
                  <div style={{ whiteSpace: "normal", maxWidth: 300 }}>
                    {remainingEmails}
                  </div>
                }
                placement="top"
                trigger="hover"
              >
                <CButton
                  size="sm"
                  color="link"
                  style={{ padding: "0 4px", textDecoration: "underline" }}
                >
                  +{remainingUsers.length} more
                </CButton>
              </CPopover>
            </>
          )}
        </td>
      );
    },
    CreatedAt: (item) => {
      const date = new Date(item.CreatedAt);
      return (
        <td>
          {date.toLocaleDateString()} {date.toLocaleTimeString()}
        </td>
      );
    },
  };

  return (
    <div className="container-fluid p-4">
      <h2 className="mb-4">Notification Logs</h2>

      <CCard>
        <CCardHeader>Recent Notifications</CCardHeader>
        <CCardBody>
          {loading ? (
            <div className="text-center p-4">
              <span>Loading...</span>
            </div>
          ) : (
            <CSmartTable
              columns={columns}
              items={logs}
              scopedColumns={scopedColumns}
              pagination
              itemsPerPage={10}
              sorter
              tableFilter
              itemsPerPageSelect
            />
          )}
        </CCardBody>
      </CCard>
    </div>
  );
};

export default NotificationLogs;
